// ═══════════════════════════════════════════════════════════════
//  GALLERY PHOTOS — these show in the Work section of the website
//
//  TO ADD YOUR OWN PHOTO:
//    1. Copy your photo file into this folder:
//         frontend/public/gallery/
//    2. Add a block below like this:
//         {
//           src: "/gallery/my-photo.jpg",
//           cat: "residential",
//           title: "Weatherboard Repaint",
//           meta: "Exterior cladding — Glenelg",
//           span: "",
//         },
//
//  cat can be:  "residential"  "exterior"  "commercial"  "detail"
//  span can be: ""            (normal size)
//               "col-span-2"  (extra wide)
//               "col-span-2 row-span-2"  (big feature tile)
//
//  TO REMOVE a photo: delete its whole { ... } block
// ═══════════════════════════════════════════════════════════════

export const gallery = [
  {
    src: "/gallery/lakeside.jpg",
    cat: "residential",
    title: "Lakeside Residence",
    meta: "Interior And Exterior",
    span: "col-span-2 row-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1624334823455-d666b43c36c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format",
    cat: "residential",
    title: "Studio 9",
    meta: "Feature wall — Crimson",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1556912167-f556f1f39fdf?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format",
    cat: "detail",
    title: "Hartman Kitchen",
    meta: "Cabinet refinish — 2-pac",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format",
    cat: "exterior",
    title: "Birchwood Modern",
    meta: "Exterior — Full system",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1659051600842-7089a15d7f7d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format",
    cat: "commercial",
    title: "Unley Office Precinct",
    meta: "Commercial — Off-hours",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1613082294483-fec382d8367e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format",
    cat: "residential",
    title: "Burnside Dining Room",
    meta: "Interior — Heritage trim",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1762810981576-1b07f76af9d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format",
    cat: "exterior",
    title: "Hills Paving Revival",
    meta: "Paving paint — Driveway & paths",
    span: "col-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1598476543599-72c8a60894d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&auto=format",
    cat: "detail",
    title: "Pigment Study N°01",
    meta: "Lab — Colour calibration",
    span: "",
  },
];
